import { Box } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ConfirmationButton } from "../../Button/ConfirmationButton";
import { DangerButton } from "../../Button/DangerButton";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IFilterButtonsProps {
    chartPanelPropertiesMode?: boolean;
    marginTop?: string;
    onClear?: () => void;
    onCancel: (checkChanges: boolean) => void;
    onRemove?: () => void;
    onSave: () => void;
}

export const FilterButtons = (props: IFilterButtonsProps) => (
    <Box display="flex" justifyContent={(!props.onClear && !props.onRemove) ? "flex-end" : "space-between"} width="100%" sx={{ marginTop: props.marginTop ?? "1.5rem" }}>
        {props.onClear && (
            <AppButton variant="outlined" onClick={props.onClear} sx={{ marginRight: "1.5rem" }}>{Translations.Clear}</AppButton>
        )}
        <Box display="flex">
            {props.onRemove && (
                <DangerButton onClick={props.onRemove} sx={{ marginRight: ".5rem" }}>{Translations.Remove}</DangerButton>
            )}
            {props.onCancel &&
                <AppButton variant="outlined" onClick={() => props.onCancel(false)} sx={{ marginRight: ".5rem" }}>{Translations.Close}</AppButton>
            }
            <ConfirmationButton onClick={props.onSave}>{!props.chartPanelPropertiesMode ? Translations.Search : Translations.Save}</ConfirmationButton>
        </Box>
    </Box>
);
